export default __webpack_public_path__ + "static/logistic-image-370d0062c7ff1fd5ce8d84c128bee7d2.jpg";